import { useState } from 'react';
import useFollowerStore from '@/stores/FollowerStore';
import { useShallow } from 'zustand/react/shallow';

import AdvancedFilterSheet from '@/components/common/advanced-filter/AdvancedFilterSheet';

const followerFields = [
  {
    _id: 1,
    value: 'full_name',
    label: 'Full Name',
    type: 'text',
  },
  {
    _id: 2,
    value: 'biography',
    label: 'Bio',
    type: 'text',
  },
  {
    _id: 3,
    value: 'is_verified',
    label: 'Is Verified',
    type: 'boolean',
  },
  {
    _id: 4,
    value: 'is_business_account',
    label: 'Is Business Account',
    type: 'boolean',
  },
  {
    _id: 5,
    value: 'followers',
    label: 'Followers Count',
    type: 'number',
  },
  {
    _id: 6,
    value: 'following',
    label: 'Following Count',
    type: 'number',
  },
  {
    _id: 7,
    value: 'lead_score',
    label: 'Lead Score',
    type: 'number',
  },
];

const operatorsList = [
  {
    _id: 1,
    type: 'enum',
    value: 'is_one_of',
    label: 'is one of',
  },
  {
    _id: 2,
    type: 'enum',
    value: 'is_none_of',
    label: 'is none of',
  },
  {
    _id: 3,
    type: 'text',
    value: 'contains',
    label: 'contains',
  },
  {
    _id: 4,
    type: 'text',
    value: 'contains_exactly',
    label: 'contains exactly',
  },
  {
    _id: 5,
    type: 'text',
    value: 'is_one_of',
    label: 'is one of',
  },
  {
    _id: 6,
    type: 'text',
    value: 'is_none_of',
    label: 'is none of',
  },
  {
    _id: 7,
    type: 'boolean',
    value: 'is',
    label: 'is',
  },
  {
    _id: 8,
    type: 'number',
    value: 'is_equal',
    label: 'equals',
  },
  {
    _id: 9,
    type: 'number',
    value: 'is_less_than',
    label: 'less than',
  },
  {
    _id: 10,
    type: 'number',
    value: 'is_greater_than',
    label: 'greater than',
  },
  {
    _id: 11,
    type: 'number',
    value: 'is_not_equal',
    label: 'not equals',
  },
];

export default function FollowerFilterSheet() {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const { setAdvancedFilters, advancedFilters } = useFollowerStore(
    useShallow((state) => ({
      advancedFilters: state.advancedFilters,
      setAdvancedFilters: state.setAdvancedFilters,
    }))
  );

  // Custom validation rules
  const validationRules = {
    personalized_action_status: (value) =>
      Array.isArray(value) && value.length > 0,
  };

  return (
    <AdvancedFilterSheet
      isOpen={isFilterOpen}
      onOpenChange={setIsFilterOpen}
      filters={advancedFilters}
      onFiltersChange={setAdvancedFilters}
      title='Advanced Filters'
      triggerButtonText='Advanced Filter'
      fieldList={followerFields}
      validationRules={validationRules}
      operatorsList={operatorsList}
    />
  );
}
